module.exports = __webpack_public_path__ + "static/img/charm_level_92.dd93c94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_92.png
// module id = Wcga
// module chunks = 0